import { Path, Svg } from '@react-pdf/renderer';

export const HouseIcon = ({ color }: { color: string }) => {
  return (
    <Svg width="17px" height="17px" viewBox="0 0 24 24" style={{marginTop: '4px', marginBottom: '4px'}}>
      <Path
        fill={color}
        d="M12 3l9 8h-3v9a1 1 0 0 1-1 1h-4v-6H11v6H7a1 1 0 0 1-1-1v-9H3l9-8z"
      />
    </Svg>
  );
};
